import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Permanent short link for printed posters: /review forwards to the current Google
// review URL, so posters never need reprinting when the link changes.
export default function ReviewRedirectPage() {
  const [state, setState] = useState("loading");

  useEffect(() => {
    axios.get(`${API}/site/review-info`)
      .then((r) => {
        const url = (r.data?.review_url || "").trim();
        if (url) window.location.replace(url);
        else setState("unset");
      })
      .catch(() => setState("unset"));
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0D14] text-white grid place-items-center p-6 text-center" data-testid="review-redirect-page">
      {state === "loading" ? (
        <p className="text-lg">Opening our Google review box…</p>
      ) : (
        <div>
          <div className="text-3xl tracking-[0.3em] text-[#D99E02] mb-3">★★★★★</div>
          <p className="text-lg font-bold m-0">Thanks for wanting to leave a review!</p>
          <p className="text-sm text-white/70 mt-2">Our review page isn't connected yet — please tell us in person, it still makes our day.</p>
        </div>
      )}
    </div>
  );
}
